import { createReducer, on } from '@ngrx/store';
import * as fromOfferReference from '../actions/offer.reference.action';
import { StateSlice } from '@core/helpers/state-slice';

export type OfferReferenceState = StateSlice<string>;

export const initialState: OfferReferenceState = {
  data: '',
  loaded: false,
  loading: false,
  error: null,
};

const comparisonsReducer = createReducer(
  initialState,
  on(fromOfferReference.setOfferReference, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      loading: false,
      loaded: true,
    };
  }),
  on(fromOfferReference.clearOfferReference, () => {
    return {
      ...initialState,
    };
  })
);

export function reducer(
  state: OfferReferenceState | undefined,
  action: fromOfferReference.OfferReferenceActions
) {
  return comparisonsReducer(state, action);
}
